import { UserRole } from '@/types/auth';

/**
 * Normalize role string to UserRole enum
 * Handles both uppercase (SUPER_ADMIN) and lowercase (super_admin) formats
 */
export function normalizeRole(role: string | UserRole | undefined): UserRole | null {
  if (!role) return null;

  // If already a valid enum value, return it
  if (Object.values(UserRole).includes(role as UserRole)) {
    return role as UserRole;
  }

  // Normalize string role to lowercase with underscores
  const normalized = role.toLowerCase().replace(/-/g, '_');

  // Map to enum values
  switch (normalized) {
    case 'super_admin':
    case 'superadmin':
      return UserRole.SUPER_ADMIN;
    case 'admin':
      return UserRole.ADMIN;
    case 'user':
      return UserRole.USER;
    default:
      console.warn(`Unknown role format: ${role}, normalized to: ${normalized}`);
      return null;
  }
}

/**
 * Check if a role string matches a UserRole enum value
 */
export function isRoleMatch(role: string | UserRole | undefined, targetRole: UserRole): boolean {
  const normalized = normalizeRole(role);
  return normalized === targetRole;
}

